import type { ApiErrorKind } from './api_error'
import { isApiError } from './api_error'

const errorMessageKeys: Record<ApiErrorKind, string> = {
  AUTH_REQUIRED: 'api_error_auth_required',
  AUTH_EXPIRED: 'api_error_auth_expired',
  FORBIDDEN: 'api_error_forbidden',
  NOT_FOUND: 'api_error_not_found',
  CONFLICT: 'api_error_conflict',
  VALIDATION: 'api_error_validation',
  NETWORK: 'api_error_network',
  TIMEOUT: 'api_error_timeout',
  SERVER: 'api_error_server',
  CONFIG: 'api_error_config',
  INVALID_RESPONSE: 'api_error_invalid_response',
  BUSINESS: 'api_error_business',
  CANCELLED: 'api_error_cancelled',
  UNKNOWN: 'api_error_unknown',
}

export const getApiErrorMessageKey = (error: unknown): string =>
  isApiError(error) ? errorMessageKeys[error.kind] : errorMessageKeys.UNKNOWN

export const shouldPresentApiError = (error: unknown): boolean =>
  !isApiError(error) || (error.kind !== 'AUTH_EXPIRED' && error.kind !== 'CANCELLED')
